import type { z } from "zod";

import type { ServiceEntity } from "../model";

import { getImageUrl } from "~/entities/image/@x/service";

type NullableImageUrl = z.infer<typeof ServiceEntity.zImageAsUrl> | null;

function createImageUrl(
  apiUrl: string,
  imageId: ServiceEntity.Schema["imageId"],
): NullableImageUrl {
  return typeof imageId === "number" ? getImageUrl(apiUrl, imageId) : null;
}

export { createImageUrl };
export type { NullableImageUrl };
